import { TFunction } from "i18next";

/**
 * Status label for a TRACKER (Profile Tracker) list.
 *
 * Trackers monitor a fixed set of companies rather than fill toward a lead goal, so a
 * progress percentage is meaningless for them (it reads as a permanent 0% — PREC-3601).
 * Instead they show how many companies they're watching, falling back to a plain
 * "Monitoring" label when the count is 0 or has not loaded yet.
 *
 * The count is coerced because SQL aggregate counts can arrive as strings (see web
 * CLAUDE.md §6).
 */
export function getTrackerStatusLabel(
	t: TFunction<"translation">,
	trackerOrganizationCount?: number | null
): string {
	const count = Number(trackerOrganizationCount ?? 0) || 0;

	return count > 0 ? t("list.tracker.trackingCount", { count }) : t("list.tracker.monitoring");
}
